<script setup lang="ts">
import { computed } from 'vue'
// 修复配置审查#11：备案号类型收口到 types/system-config 的 PublicFilingInfo，
// 不再在本组件里另抄一份结构体（两处字段名靠人工保持同步）
import type { PublicFilingInfo } from '@/types/system-config'

interface Props {
  columns?: { title: string; links: { label: string; href: string }[] }[]
  filingInfo?: PublicFilingInfo | null
}

const props = withDefaults(defineProps<Props>(), {
  columns: () => [],
  filingInfo: null,
})

const company = computed(() => props.filingInfo?.companyFullName ?? '智台账')
const icp = computed(() => props.filingInfo?.icpNumber ?? '')
const ps = computed(() => props.filingInfo?.publicSecurityNumber ?? '')
</script>

<template>
  <footer
    id="footer"
    class="bg-[#1D2129] px-6 py-12 text-gray-400"
  >
    <div class="mx-auto max-w-6xl">
      <div class="grid gap-8 sm:grid-cols-2 md:grid-cols-4">
        <div v-for="(col, ci) in columns" :key="ci">
          <h3 class="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-300">
            {{ col.title }}
          </h3>
          <ul class="space-y-2">
            <li v-for="(link, li) in col.links" :key="li">
              <a
                :href="link.href"
                class="text-sm transition-colors hover:text-white"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="mt-12 border-t border-gray-700 pt-8 text-center text-sm">
        <p>&copy; 2026 {{ company }} 版权所有</p>
        <p v-if="icp || ps" class="mt-2">
          <a
            v-if="ps"
            href="https://beian.mps.gov.cn/#/query/webSearch"
            target="_blank"
            rel="noopener noreferrer"
            class="transition-colors hover:text-white"
          >{{ ps }}</a>
          <span v-if="ps && icp"> | </span>
          <a
            v-if="icp"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
            rel="noopener noreferrer"
            class="transition-colors hover:text-white"
          >{{ icp }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>
